import { Result, Button, Typography, Layout } from "antd";
const { Content } = Layout;

const { Paragraph, Text } = Typography;

export const ErrorFallbackComponent = ({
  error,
  componentStack,
  resetErrorBoundary,
}: any) => {
  return (
    <Content>
      <Result
        status="error"
        title="エラーが発生しました"
        // subTitle="Please check and modify the following information before resubmitting."
        extra={[
          <Button type="primary" key="console" onClick={resetErrorBoundary}>
            HOME画面に戻る
          </Button>,
        ]}
      >
        <div className="desc">
          <Paragraph>
            <Text
              strong
              style={{
                fontSize: 16,
              }}
            >
              エラー情報:
            </Text>
          </Paragraph>
          <Paragraph>{error.message}</Paragraph>
          <Paragraph>{componentStack}</Paragraph>
        </div>
      </Result>
    </Content>
  );
};
